module.exports = __webpack_public_path__ + "img/Discord.9f95691d.svg";